module.exports = __webpack_public_path__ + "d2498f019eab2534aa664d8ae663dc5d.png";